export default __webpack_public_path__ + "static/media/me3_carousel_LeftArrow.1408fe80.svg";